import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const Services = () => {
  const { copy } = useLang();
  return (
    <section id="services" data-testid="services-section" className="border-t hairline">
      <div className="py-16 md:py-20 px-6 md:px-12 max-w-[1600px] mx-auto">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="overline-label mb-6">{copy.services.overline}</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
              {copy.services.titleA}<br />
              {copy.services.titleB} <span className="italic text-gold-dark">{copy.services.titleItalic}</span>
            </h2>
          </div>
          <p className="text-sm font-light text-plum/60 max-w-xs leading-relaxed">
            {copy.services.hint}
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t hairline">
        {copy.services.items.map((s) => (
          <div
            key={s.n}
            data-testid={`service-${s.n === "I" ? "residential" : s.n === "II" ? "commercial" : s.n === "III" ? "turnkey" : "landscaping"}`}
            className="group relative border-b md:border-e hairline last:border-e-0 md:[&:nth-child(2n)]:border-e-0 lg:[&:nth-child(2n)]:border-e lg:last:border-e-0 md:[&:nth-child(n+3)]:border-b-0 lg:border-b-0 min-h-[380px] md:min-h-[440px] overflow-hidden"
          >
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover scale-105 group-hover:scale-100 transition-transform duration-[1.2s] ease-out" />
              <div className="absolute inset-0 bg-plum/70" />
            </div>

            <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-12">
              <div className="flex items-start justify-between">
                <span className="font-serif text-lg text-gold-dark group-hover:text-cream transition-colors duration-500">{s.n}</span>
                <ArrowUpRight
                  size={20}
                  strokeWidth={1.25}
                  className="text-plum/40 group-hover:text-cream group-hover:rotate-45 transition-all duration-500 rtl:-scale-x-100"
                />
              </div>
              <div>
                <h3 className="font-serif text-3xl md:text-4xl group-hover:text-cream transition-colors duration-500">{s.title}</h3>
                <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-700 ease-out">
                  <div className="overflow-hidden">
                    <p className="pt-5 text-sm font-light leading-relaxed text-plum/70 group-hover:text-cream/85 transition-colors duration-500">
                      {s.detail}
                    </p>
                    <ul className="pt-5 flex flex-wrap gap-x-6 gap-y-2">
                      {s.points.map((p) => (
                        <li key={p} className="text-[10px] uppercase tracking-[0.3em] text-gold-dark group-hover:text-cream/90 transition-colors duration-500">
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
